import { Routes, Route } from "react-router-dom"
import JobQueue from "./pages/JobQueue"
import NotFoundError from "../../components/Alerts/NotFoundError"
import IndividualJob from "./pages/IndividualJob"

export default function JobsRoutes() {
    return (
        <Routes>
            <Route index element={<JobQueue />} />
            <Route path=':id' element={<IndividualJob />} />
            <Route path='404' element={<NotFoundError />} />
        </Routes>
    )
}